export class Login {
    dsEmail: string = '';
    cdSenha: string = '';
}

export class RecSenha {
    numSenha: string = '';
    confSenha: string = '';
    codSenha: string = '';
}

export class ViewRetornoRecSenha {
    validaSenha: boolean = false;

}
